module.exports = __webpack_public_path__ + "img/ajans-press-courier-ad-01.07e2eb91.jpg";